const IONIC_APP_VERSION = '5.0.2';
const LOCAL_STORAGE_KEY_NAME = 'ypa-data';
const SESSION_KEY_NAME = 'ypa-user-session';

// https://portal.document360.io/52ce8ad6-e2c5-4942-8664-718c9d5b32cb/document/v1/view/2c8f0800-e5a5-4ea9-80a6-4631219328af
export const CANCELLED_SUBSCRIPTION_STATUSES = [4, 6, 9];

const messageEvents = {
  setAuthData: 'setAuthData',
};

const mobile = {
  store: {
    android:
      'https://play.google.com/store/apps/details?id=com.porter.ion_porter',
    apple: 'https://apps.apple.com/us/app/id1032870693',
  },
  device: 'guestyforhosts://',
};

export default {
  IONIC_APP_VERSION,
  LOCAL_STORAGE_KEY_NAME,
  SESSION_KEY_NAME,
  messageEvents,
  mobile,
};
